@import "../../../../../shared/styles/base";
@import "../../../../../shared/components/design-system/Button/styles/surfaces";

.SidePanel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  @include white-surface;

  width: 100%;
  max-width: 22rem;
  height: 100%;
  max-height: 100vh;
  padding: 1rem 2rem;

  > header {
    padding: 0.5rem 0 1.5rem;
  }

  background: #fff;
  box-shadow: 0 0 20px #00000029;

  display: flex;
  flex-direction: column;

  &.closed {
    visibility: hidden;
    transform: translateX(100%);
    transition: transform 200ms ease-in, visibility 200ms ease-in;
  }

  &.open {
    visibility: visible;
    transform: translateX(0);
    transition: transform 200ms ease-out;
  }
}

.ScrollableContent {
  margin: 0 -2rem;
  padding: 0 2rem;
  flex-grow: 1;
  overflow-y: auto;
}
